import { Route } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { LoginGuard } from '../guards/login.guard';
import { UserRole } from '../enums/user-role';
import { RoleGuard } from '../guards/role.guard';
import { environment } from 'src/environments/environment';
import { WlmhGuard } from '../guards/wlmh.guard';
import { NoBaseGuard } from '../guards/no-base.guard';

export const APP_ROUTES: Route[] = [
  {
    path: 'login',
    loadComponent: () =>
      import('../features/login/login.component').then(
        (mod) => mod.LoginComponent,
      ),
    canActivate: [LoginGuard],
  },
  {
    path: 'home',
    loadComponent: () =>
      import('../features/home/home.component').then(
        (mod) => mod.HomeComponent,
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [UserRole.PORTAL_ADMINISTRATOR],
    },
  },
  {
    path: 'roles-and-permissions',
    loadComponent: () =>
      import(
        '../features/roles-and-permissions/roles-and-permissions.component'
      ).then((mod) => mod.RolesAndPermissionsComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [UserRole.PORTAL_ADMINISTRATOR],
    },
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('../features/dashboard/dashboard.component').then(
        (mod) => mod.DashboardComponent,
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [UserRole.LOCATING_OPERATOR, UserRole.UNIT_ADMINISTRATOR],
    },
  },
  {
    path: 'qr-code',
    loadComponent: () =>
      import('../features/qr-code/qr-code.component').then(
        (mod) => mod.QrCodeComponent,
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [UserRole.UNIT_ADMINISTRATOR],
    },
  },
  {
    path: 'assignments',
    loadComponent: () =>
      !environment.isWlmhEnabled
        ? import('../features/assignment/assignment.component').then(
            (mod) => mod.AssignmentComponent,
          )
        : import('../features/dashboard/dashboard.component').then(
            (mod) => mod.DashboardComponent,
          ),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [UserRole.UNIT_ADMINISTRATOR],
    },
  },
  {
    path: 'code-teams',
    loadComponent: () =>
      import('../features/code-team/code-team.component').then(
        (mod) => mod.CodeTeamComponent,
      ),
    canActivate: [AuthGuard, RoleGuard, WlmhGuard],
    data: {
      roles: [UserRole.LOCATING_OPERATOR],
    },
  },
  {
    path: 'reports',
    loadComponent: () =>
      import('../features/report/report.component').then(
        (mod) => mod.ReportComponent,
      ),
    canActivate: [AuthGuard, RoleGuard, NoBaseGuard],
    data: {
      roles: Object.values(UserRole),
    },
    runGuardsAndResolvers: 'always',
    pathMatch: 'full',
  },

  {
    path: 'web-portal-configuration',
    loadComponent: () =>
      import(
        '../features/web-portal-configuration/web-portal-configuration.component'
      ).then((mod) => mod.WebPortalConfigurationComponent),
    canActivate: [AuthGuard, RoleGuard, WlmhGuard],
    data: {
      roles: [UserRole.PORTAL_ADMINISTRATOR],
    },
  },
  {
    path: 'global-configuration',
    loadComponent: () =>
      import(
        '../features/global-configuration/global-configuration.component'
      ).then((mod) => mod.GlobalConfigurationComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [UserRole.PORTAL_ADMINISTRATOR],
    },
  },
  {
    path: 'mobile-locations',
    loadComponent: () =>
      import('../features/map/map.component').then((mod) => mod.MapComponent),
    canActivate: [AuthGuard, RoleGuard, WlmhGuard],
    data: {
      roles: [UserRole.PORTAL_ADMINISTRATOR],
    },
  },
  {
    path: 'mobile-app-configuration',
    loadComponent: () =>
      import('../features/mobile-app/mobile-app.component').then(
        (mod) => mod.MobileAppComponent,
      ),
    canActivate: [AuthGuard, RoleGuard, WlmhGuard],
    data: {
      roles: [UserRole.PORTAL_ADMINISTRATOR],
    },
  },
  {
    path: 'staff-scheduler',
    loadComponent: () =>
      import('../features/staff-scheduler/staff-scheduler.component').then(
        (mod) => mod.StaffSchedulerComponent,
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [UserRole.SECURITY_MANAGER],
    },
  },
  {
    path: 'floor-plan',
    loadComponent: () =>
      import('../features/floor-plan/floor-plan.component').then(
        (mod) => mod.FloorPlanComponent,
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [UserRole.SECURITY_COMMAND_CENTRE],
    },
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
];
